import { render, staticRenderFns } from "./WordRatingList.vue?vue&type=template&id=2b90c68e&scoped=true"
import script from "./WordRatingList.vue?vue&type=script&lang=js"
export * from "./WordRatingList.vue?vue&type=script&lang=js"
import style0 from "./WordRatingList.vue?vue&type=style&index=0&id=2b90c68e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90c68e",
  null
  
)

export default component.exports